import './styles.scss';

export const AnswerBadge = ({ answer, bold = true }) => {
  return <div className="answer_badge__container" style={!bold ? { fontWeight: 400 } : {}}>
    {answer}
  </div>
}
